<template>
  <div>
    <span class="formName">姓名会自动同步到用户信息</span>
  </div>
</template>

<script>
export default {
  name: 'FormName',
  components: {},
  data() {
    return {
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang='scss' scoped>
.formName {
  font-size: 14px;
  color: #999;
}
</style>
